import fetch from './fetch.js'

// 登录
export function login (data) {
  return fetch({
    url: '/api/login/',
    method: 'post',
    data: data
  })
}
// // 登出
// export function logout () {
//   return fetch({
//     url: '',
//     method: 'post'
//   })
// }
const getList = params => {
  return fetch({
    url: `/api/task/myte/`,
    method: 'get',
    params: params
  })
}



const getInvalidReason = params => {
  return fetch({
    url: `/api/invalid_reason/myte/`,
    method: 'get',
    params: params
  })
}

const gettaskdetail = params => {
  return fetch({
    url: `/api/task_detail/myte/`+params.id+'/',
    method: 'get',
    params: ''
  })
}

const getfiletype = params => {
  return fetch({
    url: `/api/invoice_type/myte/`,
    method: 'get',
    params: params
  })
}

const getCount = params => {
  return fetch({
    url: `/api/summary_info/myte/`,
    method: 'get',
    params: params
  })
}

export function putData (data) {
  return fetch({
    url: '/api/ocr_result_detail/myte/',
    method: 'post',
    data: data
  })
}

export function createTask (data) {
  return fetch({
    url: '/api/task/myte/',
    method: 'post',
    data: data
  })
}


const getDetail = params => {
  return fetch({
    url: `/api/task_file/myte/${params.id}/`,
    method: 'get',
    params: ''
  })
}

const getDetailBbox = params => {
  return fetch({
    url: `/api/ocr_result/myte/${params}/`,
    method: 'get',
    params: ''
  })
}

const collectionList = params => {
  return fetch({
    url: `collection/list`,
    method: 'get',
    params: ''
  })
}

const createCollection = params => {
  return fetch({
    url: `collection/add`,
    method: 'post',
    data: params
  })
}

const processList = params => {
  return fetch({
    url: `process/list`,
    method: 'get',
    params: ''
  })
}

const transportList = params => {
  return fetch({
    url: `transfer/list/${params}`,
    method: 'get',
    params: ''
  })
}

const AddTransport = params => {
  return fetch({
    url: `transfer/append`,
    method: 'post',
    data: params
  })
}

const orderList = params => {
  return fetch({
    url: `/api/data/${params.category}/${params.limit}/${params.page}`,
    method: 'get',
    params: ''
  })
}

const articleList = params => {
  return fetch({
    url: `/api/search/query/listview/category/Android/count/${params.limit}/page/${params.page}`,
    method: 'get',
    params: ''
  })
}

const userList = params => {
  return fetch({
    url: '/api/person/getPersonListByCompany',
    method: 'get',
    params: params
  })
}

/**
 * 提交用户注册信息
 * @param params
 */
const postUserInfo = params => {
  return fetch({
    url: '',
    method: 'post',
    data: params
  })
}

/**
 * 验证邮箱 token是否过期
 * @param params
 */
const checkToken = params => {
  return fetch({
    url: '',
    method: 'get',
    params: params
  })
}
const apiList = {
  login,
  getList,
  getInvalidReason,
  getfiletype,
  getDetail,
  createTask,
  gettaskdetail,
  getCount,
  getDetailBbox,
  processList,
  transportList,
  AddTransport,
  createCollection,
  collectionList,
  orderList,
  articleList,
  userList,
  postUserInfo,
  checkToken
}

export default apiList



// WEBPACK FOOTER //
// ./src/api/api.js